import { useEffect } from 'react'
import { notificationSocket } from './socketManager'

export default function useNotificationSocket(callbacks: {
	onUserNotification?: (unreadCount: number) => void
}) {
	useEffect(() => {
		notificationSocket.on('user-notification', (payload: string) => {
			const data = JSON.parse(payload)
			callbacks.onUserNotification?.(data.unreadCount)
		})
		notificationSocket.connect()

		return () => {
			notificationSocket.off('user-notification')
			notificationSocket.disconnect()
		}
	}, [])
}
